/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */

// component
import React, { useState, useEffect } from "react";
import Button from "components/Button";
import H1 from "components/H1";
import H4 from "components/H4";
import TextInput from "components/TextInput";
import { Alert,AlertType } from "utils/Alert";

// library
import { useLocation,Redirect,useHistory } from "react-router-dom";
import styled from "styled-components";

// helper
import { isValidPassword, initialValidationPassword, isPassword } from "utils/regexExp";

// servicess
import authSvc from "services/authSvc";

const Wrapper = styled.div`
  padding: 20px 50px;
  max-width: 650px;
`;

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ResetPasswordPage = () => {
  const initialValidation = {
    password: { isValid: true, msg: "" },
    confirmPassword: { isValid: true, msg: "" },
  };
  const query = useQuery();
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [validation, setValidation] = useState(initialValidation);
  const [tooltipValidation, setTooltipValidation] = useState({
    visible: false,
    value: initialValidationPassword(),
  });

  const history = useHistory();

  useEffect(() => {
    const tokenData = query.get("token");
    setToken(tokenData);
  }, []);

  useEffect(() => {
    // update tooltip validation
    if (password) {
      const validationPassword = isValidPassword(password);
      const foundFalse = validationPassword.find((item) => !item.isValid);
      setTooltipValidation({ visible: !!foundFalse, value: validationPassword });
    } else {
      setTooltipValidation({ visible: false, value: initialValidationPassword() });
    }
  }, [password]);

  const redirectToMenu = () => {
    return <Redirect to="/auth/login" />;
  };

  const handleForgotPassword = async () => {
    setLoading(true);
    const isValid = validateForm();

    if (!isValid) {
      setLoading(false);
      return;
    }

    const { isSuccess, data } = await submitResetPassword();
    if (isSuccess) {
      Alert.showStatus(
        AlertType.SUCCESS,
        'Success!',
        data
      )
      redirectToMenu();
      setTimeout(()=>{
        history.push("/auth/login"); 
      },4000)
    }else{
      Alert.showStatus(
        AlertType.ERROR,
        'Error!',
        'Opps, your request is expired. Please try again!'
      )
      setTimeout(()=>{
        history.push("/auth/login"); 
      },4000)
    }
    setLoading(false);
  };

  const validateForm = () => {
    let validationForm = initialValidation;
    if (!password) {
      validationForm = {
        ...validationForm,
        password: { ...validationForm.password, isValid: false, msg: "Password is required" },
      };
    }
    if (!confirmPassword) {
      validationForm = {
        ...validationForm,
        confirmPassword: {
          ...validationForm.confirmPassword,
          isValid: false,
          msg: "Password Confirmation is required",
        },
      };
    }

    if (password && confirmPassword && password !== confirmPassword) {
      validationForm = {
        ...validationForm,
        password: {
          ...validationForm.password,
          isValid: false,
          msg: "Password not match with Password Confirmation",
        },
        confirmPassword: {
          ...validationForm.confirmPassword,
          isValid: false,
          msg: "Password Confirmation not match with Password",
        },
      };
    }

    if (password && !isPassword(password)) {
      validationForm = {
        ...validationForm,
        password: { ...validationForm.password, isValid: false, msg: "Password not valid" },
      };
    }

    setValidation(validationForm);

    let result = true;
    Object.entries(validationForm).forEach(([key, { isValid }]) => {
      if (!isValid) result = false;
    });

    if (tooltipValidation.visible) {
      result = false;
    }

    return result;
  };

  const submitResetPassword = () => {
    return authSvc.resetPassword({ password, confirmPassword }, token).then(
      (response) => {
        return { isSuccess: true, data: response?.data?.description };
      },
      (err) => {
        return { isSuccess: false, data: err.response?.data?.data[0]?.msg || err.messages };
      }
    );
  };

  return (
    <Wrapper className="row mx-auto justify-content-center align-items-center flex-column">
      <H1 className="margin-bottom-15">Change Password</H1>
      <H4 className="margin-bottom-30">
        Don’t include common words or names. Combine uppercase or lowercase letters, number, and
        symbol.
      </H4>
      <TextInput
        inputType="password"
        title="New password"
        value={password}
        placeholder="Enter your new password"
        className="margin-bottom-20"
        onChange={(event) => setPassword(event.target.value)}
        invalidFeedback={validation?.password?.msg}
        tooltipValidation={tooltipValidation}
      />
      <TextInput
        inputType="password"
        title="Confirm new password"
        value={confirmPassword}
        placeholder="Enter your new password"
        className="margin-bottom-40"
        onChange={(event) => setConfirmPassword(event.target.value)}
        invalidFeedback={validation?.confirmPassword?.msg}
      />
      <Button
        className="w-100"
        loading={loading}
        handleRoute={() => handleForgotPassword()}
        primary
      >
        Change Password
      </Button>
    </Wrapper>
  );
};

export default ResetPasswordPage;
